var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 140,
    viewBox: "0 0 217 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165.088 36.9075C159.531 26.5763 151.459 17.7948 141.549 11.3434C130.147 3.92245 116.896 0 103.224 0C69.2358 0 40.4323 24.141 34.2699 56.9256C14.6845 60.5441 0 77.6947 0 98.0316C0 121.088 18.8236 139.846 41.961 139.846H101.738V86.915L88.3215 100.285C85.848 102.748 81.8392 102.748 79.3657 100.285C76.8922 97.8196 76.8922 93.8249 79.3657 91.36L103.593 67.2189C106.065 64.7541 110.074 64.7541 112.547 67.2189L136.775 91.36C139.248 93.8249 139.248 97.8196 136.775 100.285C135.538 101.517 133.917 102.133 132.298 102.133C130.677 102.133 129.056 101.517 127.819 100.285L114.402 86.915V139.846H164.488C192.97 139.846 216.14 116.756 216.14 88.3742C216.14 60.1924 193.295 37.2279 165.088 36.9075Z",
    fill: "#3399FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.03b92c22f758f4fddd373c92eb06a147.svg";
export { ForwardRef as ReactComponent };